// extracted by mini-css-extract-plugin
export default {"unauthorized":"Unauthorized_unauthorized__dIEKz"};